import * as React from 'react';

import { CateringPageView } from './catering-page.view';
import { useFeatureCateringPage } from './use-feature-catering-page';

const CateringPage = () => {
  const { featureCateringPageLoading, featureCateringPage } = useFeatureCateringPage();
  return (
    <CateringPageView
      isLoading={featureCateringPageLoading}
      featureCateringPage={featureCateringPage}
    />
  );
};

export default CateringPage;
